export interface SegmentsBuilder<T> extends Iterable<T> {
	next(): null | [T, SegmentsBuilder<T>];
	shift(item: T): SegmentsBuilder<T>;
}

export type MergeSegments<T> = (current: T, next: T) => ReadonlyArray<T>;

class Segment<T> implements SegmentsBuilder<T> {
	public constructor(
		private readonly merge: MergeSegments<T>,
		private readonly tail: SegmentsBuilder<T>,
		private readonly item: T,
	) {}

	public next(): [T, SegmentsBuilder<T>] {
		return [this.item, this.tail];
	}

	public shift(next: T): SegmentsBuilder<T> {
		return this.merge(this.item, next).reduceRight<SegmentsBuilder<T>>(
			(tail, item) => new Segment(this.merge, tail, item),
			this.tail,
		);
	}

	public [Symbol.iterator](): Iterator<T> {
		let current: SegmentsBuilder<T> = this;

		return {
			next() {
				const child = current.next();

				if (child == null) {
					return { value: null, done: true };
				}

				const [item, tail] = child;

				current = tail;

				return { value: item, done: false };
			},
		};
	}
}

export class SegmentEdge<T> implements SegmentsBuilder<T> {
	public constructor(private readonly merge: MergeSegments<T>) {}

	public next(): null {
		return null;
	}

	public shift(item: T): SegmentsBuilder<T> {
		return new Segment(this.merge, this, item);
	}

	public [Symbol.iterator](): Iterator<T> {
		return {
			next() {
				return { value: null, done: true };
			},
		};
	}
}
